// @flow
import * as R from "ramda"

import Price from "common/records/Price"
import type { PriceParams } from "common/records/Price"
import type { MealOptionsInput } from "mmb/records/mealsInput"
import type { ItineraryMealOptions } from "../mealTypes"

/*
 * This mapper converts price in the meal option to FE Price Class. It doesn't change anything else.
 * The implementation is done by building lenses for each available meal option and then tapping in to the object and changing it all.
 * @param segments
 */
export const mapperMealOptions = (segments: MealOptionsInput): ItineraryMealOptions => {
  // filter all flights with options

  /*
   * Filter flights that have some options so we can replace the price there
   * @type {Array<$NonMaybeType<[string, *]>>|Array<[string, *]>}
   */
  const flightsWithOptions = Object.entries(segments).filter(
    // $FlowFixMe - Object.entries cannot be typed properly
    ([, segmentInfo]: [string, MealOptionsInput]) => Object.keys(segmentInfo.options).length,
  )

  // TODO add type for segment Info
  const foodIdsForEachSegment = flightsWithOptions.map(
    ([segmentId, segmentInfo]: [string, MealOptionsInput]) => ({
      segmentId,
      foodIds: Object.keys(segmentInfo.options),
    }),
  )

  const listWithLenses = foodIdsForEachSegment.map(({ segmentId, foodIds }) =>
    foodIds.map(foodId => R.lensPath([segmentId, "options", foodId, "price"])),
  )

  const listOfFns = R.flatten(listWithLenses).map(lens => obj => {
    const { amount, base, service, merchant, service_flat } = R.view(lens, obj) // eslint-disable-line camelcase

    const changedPrice: PriceParams = {
      amount: parseFloat(amount),
      base: parseFloat(base),
      service: parseFloat(service),
      merchant: parseFloat(merchant),
      serviceFlat: parseFloat(service_flat),
    }

    return R.set(lens, new Price(changedPrice), obj)
  })

  /*
   * Run all lenses on the original meals BE response object
   */
  const result = listOfFns.reduce(
    (objectWithMeals, fnModifyingPrice) => fnModifyingPrice(objectWithMeals),
    segments,
  )

  /*
   * merge flights with no options with now altered meals
   */
  // $FlowFixMe
  return R.mergeAll([segments, result])
}
